import { Typography, TypographyProps } from '@mui/material';

import { styled } from '@mui/material/styles';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';

export const BodySmallBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 0.875rem ${RookeryBoldFont}`,
  textTransform: 'none',
}));

export const BodySmallRegularStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 0.875rem ${RookeryRegularFont}`,
}));
